import { createGlobalStyle } from 'styled-components';
import { normalize } from 'polished';
import { Theme } from '../../../theme';
import nProgress from './nprogress';

interface GlobalStyleProps {
  theme: Theme;
}

const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
  ${normalize()}
  ${(p) => nProgress(p.theme)}

  @font-face {
    font-family: 'Public Sans Variable';
    font-style: normal;
    font-display: swap;
    font-weight: 100 900;
    src: url(/fonts/public-sans-latin-ext-wght-normal.woff2) format('woff2-variations');
    unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329,
      U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }

  @font-face {
    font-family: 'Public Sans Variable';
    font-style: normal;
    font-display: swap;
    font-weight: 100 900;
    src: url(/fonts/public-sans-latin-wght-normal.woff2) format('woff2-variations');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329,
      U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  @font-face {
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src: url(/fonts/ibm-plex-mono-latin-400-normal.woff2) format('woff2');
  }

  html {
    box-sizing: border-box;
  }
  
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  body {
    font-family: ${(p) => p.theme.font.family};
    font-size: ${(p) => p.theme.font.size.sm};
    font-weight: ${(p) => p.theme.font.weight.normal};
    color: ${(p) => p.theme.colors.general.text};
    line-height: 1.45;
    background-color: ${(p) => p.theme.colors.general.body};
    -webkit-font-smoothing: antialiased;
    font-feature-settings: 'tnum' 0;
  }

  h1, h2, h3, h4, h5, h6 {
    color: ${(p) => p.theme.colors.general.black};
    letter-spacing: -0.01em;
  }

  button, input, select, textarea {
    font-family: inherit;
  }

  a {
    color: ${(p) => p.theme.colors.general.link};
  }

  /* Fallback for bare, unstyled inputs (e.g. inline-styled admin tools). */
  input:not([class]):not([type='checkbox']):not([type='radio']):not([type='file']):not([type='range']),
  select:not([class]) {
    height: 36px;
    padding: 0 8px;
    border: 1px solid ${(p) => p.theme.colors.grey[50]};
    border-radius: 0;
    background-color: ${(p) => p.theme.colors.general.white};
    color: ${(p) => p.theme.colors.general.black};
    font-size: ${(p) => p.theme.font.size.xs};
  }

  /* 2px tide focus ring on every interactive element. */
  :focus-visible {
    outline: 2px solid ${(p) => p.theme.colors.general.link};
    outline-offset: 2px;
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      transition-duration: 0.01ms !important;
      animation-duration: 0.01ms !important;
    }
  }
`;

export default GlobalStyle;
